module.exports = "<h1 class=\"header\">\n  Examenopdrachten\n</h1>\n<div class=\"content\">\n<p>\n  examen works!\n</p>\n</div>\n"